import MyAccountSettings from './MyAccountSettings'

export default MyAccountSettings
// eslint-disable-next-line import/export
export * from './MyAccountSettings'
